module.exports = __webpack_public_path__ + "img/diesel-locomotive-shadow-04.8486c124.png";